/* Print Pro AZ quote drawer. Loaded (deferred) by sections/ppaz-quote-drawer.liquid.
   Any element with [data-ppaz-quote-open] opens the drawer; the attribute value is logged as the source. */
(function () {
  'use strict';
  var root = document.getElementById('ppaz-quote-root');
  if (!root) return;
  var dlg = document.getElementById('ppazQuoteDrawer');
  if (!dlg) return;

  var cfg = {
    mode: root.getAttribute('data-mode') || 'shopify',
    hsPortal: root.getAttribute('data-hs-portal') || '',
    hsRegion: root.getAttribute('data-hs-region') || 'na1',
    hsForm: root.getAttribute('data-hs-form') || '',
    context: root.getAttribute('data-context') || 'general',
    contextLabel: root.getAttribute('data-context-label') || '',
    adsLabel: root.getAttribute('data-ads-label') || '',
    ga4: root.getAttribute('data-ga4') || ''
  };
  var hsScriptRequested = false, hsBuilt = false, closing = false, ga4Ready = false;

  /* Shopify's Google & YouTube pixel loads gtag on the page, but only its Ads destination is configured
     in the page itself (GA4 runs inside the pixel sandbox). Configuring the GA4 stream here, with
     page views off, lets the quote events reach GA4 without double-counting anything. */
  function ensureGa4() {
    if (ga4Ready || !cfg.ga4) return;
    ga4Ready = true;
    try { window.gtag('config', cfg.ga4, { send_page_view: false }); } catch (e) {}
  }
  /* gtag arrives asynchronously, often after this script has already run on the post-submit page, so
     wait for it (up to ~10s) rather than dropping the event. */
  function viaGtag(fn, tries) {
    tries = tries || 0;
    if (typeof window.gtag === 'function') { ensureGa4(); try { fn(); } catch (e) {} }
    else if (tries < 40) { setTimeout(function () { viaGtag(fn, tries + 1); }, 250); }
  }

  function push(obj) {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(obj); } catch (e) {}
    /* gtag.js on its own never forwards a plain dataLayer push to GA4 or Google Ads (that needs a
       Tag Manager container), so the same event is sent through gtag as well. */
    if (obj && obj.event) {
      var params = {};
      for (var k in obj) { if (k !== 'event' && Object.prototype.hasOwnProperty.call(obj, k)) params[k] = obj[k]; }
      viaGtag(function () { window.gtag('event', obj.event, params); });
    }
  }
  function lead() {
    push({ event: 'ppaz_quote_submit', quote_context: cfg.context, quote_page: cfg.contextLabel, page_path: location.pathname });
    if (cfg.adsLabel) viaGtag(function () { window.gtag('event', 'conversion', { send_to: cfg.adsLabel }); });
  }
  function lock(on) { document.documentElement.classList.toggle('ppaz-lock', !!on); }

  /* Per-lane context. A link ending in #quote-<key> swaps the headline, subhead, and request_type
     before opening, so the quote lands with the right label. Plain #quote keeps the page default. */
  var LANES = {
    'arc-flash':   { title: "Send your arc flash study. We'll print one label per piece of equipment.", sub: 'Attach the study export or the equipment schedule. Proof back the same business day, labels out in 72 hours.', rt: 'Quote request (arc flash)' },
    'solar':       { title: "Send your plan set. We'll quote the full kit.", sub: 'Every placard, site map, and conduit label the drawings call for, packed per job. Tell us the AHJ and utility.', rt: 'Quote request (solar)' },
    'pipe-markers':{ title: "Send your valve schedule. We'll quote markers and tags line by line.", sub: 'Attach the schedule or the mechanical drawings. Standard ASME colors or your own scheme. Stock ships same day.', rt: 'Quote request (pipe markers)' },
    'name-plates': { title: "Send your panel schedule. We'll quote name plates and directories.", sub: 'Attach the schedule or the equipment list. Same day on stock plates, 72 hours on custom engraving.', rt: 'Quote request (name plates)' },
    'data-center': { title: "Send the equipment schedule. We'll label the whole build.", sub: 'Switchgear to racks, electrical and mechanical. Attach the schedule, one-line, or plan set. Proof back the same business day.', rt: 'Quote request (data center)' },
    'company-store': { title: "Tell us what the crew needs. We'll set up your company store.", sub: 'Shirts, hats, flyers, door hangers, yard signs, safety signs. Attach logos or your old vendor files and we send proofs and pricing.', rt: 'Quote request (company store)' },
    'wire-labels': { title: "Send your cable schedule. We'll quote the wire labels.", sub: 'Heat shrink, wrap-around, or cable tags. Attach the schedule or legend list, and any Brady part numbers you are replacing.', rt: 'Quote request (wire & cable labels)' },
    'heat-shrink': { title: "Send your legend list. We'll quote the heat shrink.", sub: 'Wire gauge or sleeve size, quantities, and any Brady PermaSleeve part numbers you are replacing.', rt: 'Quote request (heat shrink)' },
    'wrap-around': { title: "Send your legend list. We'll quote the wrap-around labels.", sub: 'Wire size, quantities, print color, and any Brady THT part numbers you are replacing.', rt: 'Quote request (wrap-around labels)' },
    'cable-tags':  { title: "Send your cable numbers. We'll quote the tags.", sub: 'Tag material (polyethylene or stainless), quantities, and the cable schedule or list of IDs.', rt: 'Quote request (cable tags)' },
    'placards':    { title: "Send your panel or equipment schedule. We'll quote every plate.", sub: 'Phenolic, lamacoid or engraved plastic nameplates, equipment ID labels and custom placards. Attach the schedule or Excel list; proof back the same business day.', rt: 'Quote request (placards & nameplates)' },
    'job-site-signs': { title: "Send the sign list. We'll quote the job site package.", sub: 'Custom legends, logos, site rules, bilingual and bulk quantities on coroplast or aluminum composite. Attach the list or a photo of what is on the fence now.', rt: 'Quote request (job site signs)' }
  };
  var titleEl = dlg.querySelector('#ppazQuoteTitle'), subEl = dlg.querySelector('.ppaz-sub'), rtEl = dlg.querySelector('input[name="contact[request_type]"]');
  var base = { title: titleEl ? titleEl.textContent : '', sub: subEl ? subEl.textContent : '', rt: rtEl ? rtEl.value : '' };
  function setLane(key) {
    var l = (key && LANES[key]) || base;
    if (titleEl) titleEl.textContent = l.title;
    if (subEl) subEl.textContent = l.sub;
    if (rtEl) rtEl.value = l.rt;
    cfg.lane = key && LANES[key] ? key : '';
  }
  /* A page can make one lane its default (header button, mobile bar, plain #quote) with
     data-ppaz-default-lane="<key>" on any element in its content. */
  var defEl = document.querySelector('[data-ppaz-default-lane]');
  var defKey = defEl ? defEl.getAttribute('data-ppaz-default-lane') : '';
  if (defKey && LANES[defKey]) { base = LANES[defKey]; setLane(''); }
  function laneFromHash(h) { var m = /#quote(?:-([a-z-]+))?$/.exec(h || ''); return m ? (m[1] || '') : null; }

  function open(source, lane) {
    if (dlg.open || closing) return;
    if (lane !== undefined) setLane(lane);
    if (typeof dlg.showModal === 'function') { dlg.showModal(); } else { dlg.setAttribute('open', ''); }
    lock(true);
    requestAnimationFrame(function () { requestAnimationFrame(function () { dlg.classList.add('is-open'); }); });
    if (cfg.mode === 'hubspot') buildHubSpot();
    var first = dlg.querySelector('.ppaz-form-wrap:not([hidden]) input:not([type=hidden]), .ppaz-form-wrap:not([hidden]) textarea');
    if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) {} }, 320);
    push({ event: 'ppaz_quote_open', quote_source: source || 'unknown', quote_context: cfg.context, quote_lane: cfg.lane || '', page_path: location.pathname });
  }
  function close() {
    if (!dlg.open || closing) return;
    closing = true;
    dlg.classList.remove('is-open');
    var done = false;
    function finish() {
      if (done) return; done = true;
      if (dlg.open) { try { dlg.close(); } catch (e) { dlg.removeAttribute('open'); } }
      lock(false); closing = false;
    }
    dlg.addEventListener('transitionend', finish, { once: true });
    setTimeout(finish, 360);
  }
  function showSuccess() {
    var wrap = dlg.querySelector('.ppaz-form-wrap');
    var ok = dlg.querySelector('.ppaz-success');
    if (wrap) wrap.hidden = true;
    if (ok) { ok.hidden = false; var h = ok.querySelector('h3'); if (h) { h.setAttribute('tabindex', '-1'); try { h.focus(); } catch (e) {} } }
  }

  /* openers and closers, delegated so in-page links work too */
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target : null;
    if (!el) return;
    var opener = el.closest('[data-ppaz-quote-open]');
    if (opener) { e.preventDefault(); open(opener.getAttribute('data-ppaz-quote-open') || 'link'); return; }
    /* Theme buttons cannot carry data attributes, so any link whose URL ends in #quote opens the drawer too. */
    var hashLink = el.closest('a[href]');
    var laneKey = hashLink ? laneFromHash(hashLink.getAttribute('href')) : null;
    if (laneKey !== null) { e.preventDefault(); open('hash-link', laneKey); return; }
    if (el.closest('[data-ppaz-quote-close]')) { e.preventDefault(); close(); }
  });
  window.addEventListener('hashchange', function () { var k = laneFromHash(location.hash); if (k !== null) open('hash', k); });
  dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });   /* backdrop */
  dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });    /* Esc */

  /* Shopify native form. Attachments ride through the cart: as soon as a file is picked we add a $0
     helper item with the file as a line-item property, read back the hosted file URL, remove the item,
     and write the URL into contact[attachment]. The submit button stays disabled while that runs, so
     the customer's click is always a plain native submit (Shopify's spam protection needs that). The
     file input itself has no name, so it is never posted. */
  var form = dlg.querySelector('form.ppaz-form');
  var submitBtn = form ? form.querySelector('[data-ppaz-submit]') : null;
  var idleHtml = submitBtn ? submitBtn.innerHTML : '';
  var uploadVariant = root.getAttribute('data-upload-variant') || '';
  var fileInput = dlg.querySelector('[data-ppaz-file]');
  var fileText = dlg.querySelector('[data-ppaz-file-text]');
  var dropzone = dlg.querySelector('[data-ppaz-dropzone]');
  var attachField = dlg.querySelector('[data-ppaz-attachment]');
  var MAX_BYTES = 20 * 1024 * 1024;
  var IDLE_TEXT = fileText ? fileText.textContent : '';
  var uploading = false;

  function setBusy(on) {
    if (!submitBtn) return;
    submitBtn.disabled = !!on;
    if (on) { submitBtn.setAttribute('aria-busy', 'true'); submitBtn.textContent = submitBtn.getAttribute('data-uploading-label') || 'Uploading'; }
    else { submitBtn.removeAttribute('aria-busy'); submitBtn.innerHTML = idleHtml; }
  }
  function setDropState(state, text) {
    if (dropzone) { dropzone.classList.remove('has-file', 'has-error', 'is-busy'); if (state) dropzone.classList.add(state); }
    if (fileText && typeof text === 'string') fileText.textContent = text;
  }
  function cartRemove(key, attempt) {
    attempt = attempt || 1;
    return fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { if (!r.ok) throw new Error('cart change ' + r.status); return r.json(); })
      .catch(function (err) { if (attempt < 3) return cartRemove(key, attempt + 1); throw err; });
  }
  function uploadViaCart(file) {
    var fd = new FormData();
    fd.append('id', uploadVariant);
    fd.append('quantity', '1');
    fd.append('properties[Plan set]', file, file.name);
    fd.append('properties[_ppaz_upload]', 'quote');
    try { sessionStorage.setItem('ppaz_upload_pending', '1'); } catch (e) {}
    return fetch('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'cart add ' + r.status); return j; }); })
      .then(function (item) {
        var url = item && item.properties && item.properties['Plan set'];
        var done = function () { try { sessionStorage.removeItem('ppaz_upload_pending'); } catch (e) {} return url; };
        return cartRemove(item.key).then(done, function () { return url; });
      });
  }
  function startUpload(file) {
    if (!uploadVariant || !attachField) return;
    var label = file.name + ' (' + Math.max(1, Math.round(file.size / 1024)) + ' KB)';
    uploading = true;
    attachField.value = '';
    setBusy(true);
    setDropState('is-busy', 'Uploading ' + label);
    uploadViaCart(file)
      .then(function (url) {
        if (!url) throw new Error('no url');
        attachField.value = url;
        setDropState('has-file', label);
        push({ event: 'ppaz_quote_attachment', attachment_ok: true, page_path: location.pathname });
      })
      .catch(function () {
        attachField.value = '';
        setDropState('has-error', 'Upload failed. Send the form, then email us the file.');
        push({ event: 'ppaz_quote_attachment', attachment_ok: false, page_path: location.pathname });
      })
      .then(function () { uploading = false; setBusy(false); });
  }
  function onFileChange() {
    var f = fileInput && fileInput.files && fileInput.files[0];
    if (!f) { if (attachField) attachField.value = ''; setDropState(null, IDLE_TEXT); return; }
    if (f.size > MAX_BYTES) {
      fileInput.value = '';
      if (attachField) attachField.value = '';
      setDropState('has-error', 'That file is over 20 MB. Email it to us instead.');
      return;
    }
    startUpload(f);
  }
  if (fileInput) fileInput.addEventListener('change', onFileChange);
  if (dropzone && fileInput) {
    ['dragenter', 'dragover'].forEach(function (t) { dropzone.addEventListener(t, function (e) { e.preventDefault(); dropzone.classList.add('is-drag'); }); });
    ['dragleave', 'drop'].forEach(function (t) { dropzone.addEventListener(t, function (e) { e.preventDefault(); dropzone.classList.remove('is-drag'); }); });
    dropzone.addEventListener('drop', function (e) {
      try { if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) { fileInput.files = e.dataTransfer.files; onFileChange(); } } catch (err) {}
    });
  }
  /* If a previous upload was interrupted between add and remove, strip the helper item on the next visit. */
  (function cleanupLeftovers() {
    var pending = false;
    try { pending = sessionStorage.getItem('ppaz_upload_pending') === '1'; } catch (e) {}
    if (!pending || !uploadVariant) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var leftovers = (cart.items || []).filter(function (it) { return it.properties && it.properties._ppaz_upload; });
        return Promise.all(leftovers.map(function (it) { return cartRemove(it.key).catch(function () {}); }));
      })
      .then(function () { try { sessionStorage.removeItem('ppaz_upload_pending'); } catch (e) {} })
      .catch(function () {});
  })();

  if (form) {
    form.addEventListener('submit', function (e) {
      if (uploading) { e.preventDefault(); return; }
      try { sessionStorage.setItem('ppaz_submitting', '1'); } catch (err) {}
      if (submitBtn) { submitBtn.disabled = true; submitBtn.setAttribute('aria-busy', 'true'); }
    });
  }
  var posted = /[?&]contact_posted=true/.test(location.search);
  var mine = false;
  try { mine = sessionStorage.getItem('ppaz_submitting') === '1'; if (posted) sessionStorage.removeItem('ppaz_submitting'); } catch (e) {}
  if (posted && mine) { showSuccess(); open('posted'); lead(); }
  else if (dlg.querySelector('[data-ppaz-open-on-load]') && mine) { open('errors'); try { sessionStorage.removeItem('ppaz_submitting'); } catch (e) {} }
  else { var k0 = laneFromHash(location.hash); if (k0 !== null) open('hash', k0); }

  /* HubSpot mode: script is only requested when the drawer first opens */
  function buildHubSpot() {
    if (hsBuilt) return;
    var target = dlg.querySelector('.ppaz-hs-target');
    if (!target || !cfg.hsPortal || !cfg.hsForm) return;
    function create() {
      if (hsBuilt || !window.hbspt || !window.hbspt.forms) return;
      hsBuilt = true;
      target.innerHTML = '';
      window.hbspt.forms.create({
        region: cfg.hsRegion,
        portalId: cfg.hsPortal,
        formId: cfg.hsForm,
        target: '#ppaz-quote-root .ppaz-hs-target',
        onFormReady: function () {
          try {
            var f = target.querySelector('form'); if (!f) return;
            var map = { page_context: cfg.contextLabel, page_url: location.href, quote_context: cfg.context };
            Object.keys(map).forEach(function (n) {
              var i = f.querySelector('[name="' + n + '"]');
              if (i) { i.value = map[n]; i.dispatchEvent(new Event('input', { bubbles: true })); i.dispatchEvent(new Event('change', { bubbles: true })); }
            });
          } catch (e) {}
        },
        onFormSubmitted: function () { lead(); showSuccess(); }
      });
    }
    if (window.hbspt && window.hbspt.forms) { create(); return; }
    if (hsScriptRequested) return;
    hsScriptRequested = true;
    var host = (cfg.hsRegion && cfg.hsRegion !== 'na1') ? 'js-' + cfg.hsRegion + '.hsforms.net' : 'js.hsforms.net';
    var s = document.createElement('script');
    s.src = 'https://' + host + '/forms/embed/v2.js';
    s.async = true;
    s.onload = create;
    s.onerror = function () { target.innerHTML = '<p class="ppaz-loading">The form did not load. Call us or email your plan set instead.</p>'; };
    document.head.appendChild(s);
  }

  /* mobile bar: reserve space so it never covers content. In Shopify's theme preview the preview bar
     is pinned to the bottom of the screen, so sit above it there; on the published theme it does not exist. */
  var bar = root.querySelector('.ppaz-bar');
  if (bar) {
    document.body.classList.add('ppaz-has-bar');
    var lift = function () {
      var pbar = document.getElementById('PBarNextFrameWrapper');
      var h = pbar ? Math.round(pbar.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty('--ppaz-bar-offset', h + 'px');
    };
    lift();
    setTimeout(lift, 1500);
    setTimeout(lift, 4000);
    window.addEventListener('resize', lift);
  }
})();
